/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentInitialsPerPageV1Dto } from './DocumentInitialsPerPageV1Dto';
import type { DocumentInitialsV1Dto } from './DocumentInitialsV1Dto';
export type UploadDocumentPayloadV1Dto = {
  /**
   * Base64 encoded file
   */
  file: string;
  /**
   * Position of the Initials on the document
   */
  initials?: DocumentInitialsV1Dto;
  /**
   * Insert just after the position of the specified document id
   */
  insert_after_id?: string;
  /**
   * The document name. If not set, uploaded document's name will be used
   */
  name?: string;
  /**
   * Can take two values: signable_document or attachment. Files in JPEG, JPG, and PNG format can only be of attachment nature.
   */
  nature?: UploadDocumentPayloadV1Dto.nature;
  /**
   * Parse anchors in the document
   */
  parse_anchors?: boolean;
  /**
   * The password required to unlock the document if it is protected.
   */
  password?: string;
  /**
   * Y-axis position of the initials on the page.
   */
  per_page?: Array<DocumentInitialsPerPageV1Dto>;
};
export namespace UploadDocumentPayloadV1Dto {
  /**
   * Can take two values: signable_document or attachment. Files in JPEG, JPG, and PNG format can only be of attachment nature.
   */
  export enum nature {
    ATTACHMENT = 'attachment',
    SIGNABLE_DOCUMENT = 'signable_document',
  }
}
